<style scoped>
</style>

<template>
  <div>
    
    <screen-view v-if="screen" :sessionId="$route.params.sessionId" :screen="screen" :questions="questions" :screens="screens" :values="values" :error-messages="errorMessages"
      v-on:transition-to-prev-screen="prevScreen()"
      v-on:transition-to-next-screen="nextScreen($event)">
    </screen-view>

  </div>
</template>

<script>
import ScreenComponent from '../components/Screen'
import ServiceAccess from '../service/ServiceAccess'


export default {

  components: {
    'screen-view': ScreenComponent
  },

  data: function () {
    return {
      screens: null,
      questions: {},
      errorMessages: {},
      values: {}
    }
  },

  computed: {
    screen: function () {
      if (this.screens) {
        if (this.$route.params.screenId != null) {
          return this.screens.screen(this.$route.params.screenId)
        } else {
          return this.screens.screen()
        }
      }
    }
  },

  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)

    let promises = [
      ServiceAccess.instance.loadValues(this.$route.params.sessionId),
      ServiceAccess.instance.loadScreens(),
      ServiceAccess.instance.loadErrorMessages(),
      ServiceAccess.instance.loadQuestions()
    ]
    Promise.all(promises).then(responses => {
      let [values, screens, errorMessages, questions] = responses
      this.values = values
      global.navigationBarBus.$emit('display-save', values.id_user_mail == null)
      this.screens = screens
      this.errorMessages = errorMessages
      this.questions = questions
    })  
  },

  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },

  methods: {
    sessionPathTo: function (path) {
      return path + '/' + this.$route.params.sessionId
    },

    prevScreen: function () {
      let currentScreen = this.screen
      // default entry point
      let screenPath = this.screens.screenPath(this.values)
      if (!screenPath.find(s => currentScreen.id === s.id)) {
        // try 2nd entrypoint
        screenPath = this.screens.screenPath(this.values, 'parcours standard')
      }
      
      while (screenPath.length > 0) {
        let screen = screenPath.pop()
        if (screen.id === currentScreen.id) {
          break
        }
      }
      let prevScreen = screenPath.length > 0 ? screenPath.pop() : currentScreen
      if (prevScreen !== currentScreen) {
        this.$router.replace('/f/' + this.$route.params.sessionId + '/' + prevScreen.id)
      } else {
        this.$router.back()
      }

      
    },
    nextScreen: function (transitionToScreen) {
      ServiceAccess.instance.storeValues(this.$route.params.sessionId, this.values)
      this.$router.push('/f/' + this.$route.params.sessionId + '/' + transitionToScreen)
    }
  }


}
</script>



// WEBPACK FOOTER //
// Form.vue?4ef2a185